/** Порталит меню react-select в body и поднимает над модалками/поповерами. */
export const selectMenuPortalStyles = {
  menuPortal: (base: object): object => ({
    ...base,
    zIndex: 'var(--z-index-popover)',
  }),
};
